import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  align?: 'left' | 'center';
}

export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
}: SectionHeadingProps): JSX.Element {
  const alignClass = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return (
    <div className={`max-w-3xl ${alignClass}`}>
      {eyebrow !== undefined && (
        <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-honey-300/90 mb-4">
          <span className="h-px w-6 bg-honey-400/60" />
          {eyebrow}
        </div>
      )}
      <h2 className="font-display text-3xl md:text-5xl font-extrabold tracking-tight text-balance text-white">
        {title}
      </h2>
      {subtitle !== undefined && (
        <p className="mt-4 text-base md:text-lg text-cream-300/90 text-balance leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
